import React from "react";
import { ArrowBackCircle } from "react-ionicons";
import constantURI from "../URI";
import _post from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilter";
import stylesASAP from "./stylesASAP";
import ASAPAuthenticate from "../Functions/ASAPAuthenticate";
import stylesMed from "../MedRep/stylesMed";
import _postBody from "../Functions/Post";
import { db, getDocs, collection, disableNetwork } from "../firebase";
import { set, get } from "idb-keyval";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import ProgressBar from "react-bootstrap/ProgressBar";
import SalesGauge from "./SalesGauge";

export default class Target extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      UST: [],
      noData: true,
      SoRo: true,
      alertUndefined: false,
      showAlertimage: false,
      percentage: 0,
      exist: "",
      trans: [],
    };
  }

  async componentDidMount() {
    const UST = JSON.parse(localStorage.getItem("DailyData"));
    const Trans = JSON.parse(localStorage.getItem("UnsyncedTransactions"));
    const SoRo = JSON.parse(localStorage.getItem("OrderType"));
    await this.setState({ UST: UST, USTCopy: UST, SoRo: SoRo, trans: Trans });
  }

  render() {
    const salesValue = 75;
    console.log(this.state.UST);
    return (
      <div className="container-fluid vh-100" style={stylesASAP.mainContainer}>
        {/* <div className="pt-3 row">
          <div className="col">
            <ArrowBackCircle
              className="btn col"
              onClick={() => this.props.history.push("./LandingPage")}
              color={"#00bfff"}
              height="50px"
              width="50px"
            />
          </div>
        </div>
    
        <div className="row text-center mt-4">
              <div className="punch h4" style={stylesASAP.itemName}><u>Targeting</u></div>
        
          <div className="col  mt-4">
            <div className="col Box-Shadow">
              <div className=" h6 mt-3 bg-secondary text-white">
                <b className="textlog">Sales</b>
              </div>
            </div>

            <div className="col Box-Shadow">
              <div className="textlog text-dark">200$ Of 6200$</div>
            </div>
          </div>

          <div className="col  mt-4">
            <div className="col Box-Shadow">
              <div className="h6 mt-3 bg-secondary text-white">
                <b className="textlog">Clients</b>
              </div>
            </div>

            <div className="col Box-Shadow">
              <div className="textlog text-dark">20 Of 52</div>
            </div>
          </div>
         
        </div> */}

        
        <SalesGauge />
      </div>
    );
  }
}
